import {
  Button,
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
  Typography
} from '@material-tailwind/react'
import { FiAlertTriangle } from 'react-icons/fi'
import { confirmable } from 'react-confirm'
import PropTypes from 'prop-types'

const ModalConfirmation = ({ show, proceed, title, description }) => {
  return (
    <Dialog open={show} size='sm' className='p-3'>
      <DialogHeader className='pb-0'>
        <div className='w-16 h-16 bg-amber-50 border-amber-50 p-3 rounded-[28px] text-amber-900'>
          <div className='bg-amber-100 rounded-[28px] p-3 w-10 h-10  relative flex-col justify-start items-start flex'>
            <FiAlertTriangle
              size='1.5rem'
              className='absolute m-auto top-0 bottom-0 left-0 right-0'
            />
          </div>
        </div>
      </DialogHeader>
      <div className='flex flex-col gap-3'>
        <DialogBody>
          <Typography variant='h6' className='text-black text-lg'>
            {title}
          </Typography>
          <Typography variant='small'>{description}</Typography>
        </DialogBody>
        <DialogFooter className='grid grid-cols-2 gap-4'>
          <Button
            variant='outlined'
            size='lg'
            fullWidth
            color='gray'
            onClick={() => proceed(false)}
            className='mr-1 normal-case'
          >
            Cancelar
          </Button>
          <Button
            fullWidth
            color='blue'
            onClick={() => proceed(true)}
            size='lg'
            className='normal-case'
          >
            Sí, cambiar
          </Button>
        </DialogFooter>
      </div>
    </Dialog>
  )
}

ModalConfirmation.defaultProps = {
  title: '',
  description: ''
}
ModalConfirmation.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  show: PropTypes.bool,
  proceed: PropTypes.func,
  options: PropTypes.object // arguments of your confirm function
}

export const Confirmation = confirmable(ModalConfirmation)
